export const Separator = '||SEP||';